import { createRouter, createWebHistory } from 'vue-router'

import { generateRoutes } from '@/extensions/langRouter'

const routes = [
  {
    path: '/',
    paths: { en: '/' },
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/cabinet',
    paths: { en: '/firm' },
    name: 'office',
    component: () => import('@/views/Office.vue'),
  },
  {
    path: '/services',
    paths: { en: '/services' },
    name: 'services',
    component: () => import('@/views/Services.vue'),
  },
  {
    path: '/rh',
    paths: { en: '/hr' },
    name: 'hr',
    component: () => import('@/views/HumanResources.vue'),
  },
  {
    path: '/partenaires',
    paths: { en: '/partners' },
    name: 'advantages',
    component: () => import('@/views/Advantages.vue'),
  },
  {
    path: '/carrieres',
    paths: { en: '/careers' },
    name: 'careers',
    component: () => import('@/views/Careers.vue'),
  },
  {
    path: '/non-responsabilite',
    paths: { en: '/disclaimer' },
    name: 'disclaimer',
    component: () => import('@/views/Disclaimer.vue'),
  },
  {
    path: '/politique-de-confidentialite',
    paths: { en: '/privacy-policy' },
    name: 'privacy-policy',
    component: () => import('@/views/PrivacyPolicy.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    redirect: '/',
  },
]

const localizedRoutes = generateRoutes(routes, 'fr', ['en'])

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: localizedRoutes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: window.innerWidth > 1024 ? 130 : 75,
      }
    }
    return { top: 0, behavior: 'smooth' }
  },
})

export default router
